import { createContext } from "react";

export type ThemeMode = "light" | "dark";

export interface ThemeContextValue {
  themeMode: ThemeMode;
  setThemeMode: (mode: ThemeMode) => Promise<void>;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue>({
  themeMode: "light",
  setThemeMode: async () => {},
  toggleTheme: () => {},
});